<template>
  <div class="imdiv" v-on:click="goFolder">
    <div class="square-filler" >
      <transition name="fade">
        <img v-if="seen" :src="imageUrl" :alt="foldername" class="main"  />
      </transition>
    </div>
    <div class="greybar">
      <div>
        <div class="a-name">{{ foldername }}</div>
        <div class="likebox-holder"><div class="liked-box liked"></div></div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
export default {
  mixins: [ViewablePanel],
  props: {
    image: Object,
    foldername: String
  },
  data () {
    return {
      imageUrl: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    goFolder() {
      this.$emit('click')
    },
    async init () {
      if(!this.image) return
      this.imageUrl = this.$k.getImageCrop320(this.image.url)
    },
  },
  watch: {
    image () {
      this.init()
    }
  }
}
</script>

<style scoped>
.imdiv{
  transition: all 0.3s linear;
}
.imdiv.hide{
  opacity:0;
}

.square-filler{
  pointer-events: all;
}

img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}
.square-filler{
  position:relative;
  overflow:hidden;
}
.imdiv:hover img.main{
  width:107%;
}

.imdiv:hover .greybar{
  background-color:#ce0e2d;
  color:#fff;
}

.imdiv:hover .liked-box.liked{
  background-image:url('../../assets/img/heart-white.svg');
}
</style>